import { IntlShape } from 'react-intl';

import { DeliveryStatus } from 'state/order';
import { TLocalizationKey } from 'types/i18n';

import { UnavailabilityReason, UnavailabilityReasonObject, unavailabilityReasonMap } from './types';

const getModaTitleId = (reason: UnavailabilityReason): TLocalizationKey =>
  reason === UnavailabilityReason.REDUCED_CAPACITY
    ? 'unavailabilityReasonLimited'
    : 'unavailabilityReasonPaused';

const getAllTextId = (reason: UnavailabilityReason) => {
  const errorModalTitleId = getModaTitleId(reason);

  const {
    subtitle: errorModalSubTitleId,
    body: errorModalBodyId,
    feedBackMessage: errorModalFeedbackId,
    icon: errorModalIcon,
  } = unavailabilityReasonMap[reason];

  return {
    errorModalTitleId,
    errorModalSubTitleId,
    errorModalBodyId,
    errorModalFeedbackId,
    errorModalIcon,
  };
};

export const getUnavailabilityReason = (
  unavailabilityReason: UnavailabilityReason | null,
  deliveryStatus: DeliveryStatus,
  formatMessage: IntlShape['formatMessage']
): UnavailabilityReasonObject | null => {
  const isDeliveryError = deliveryStatus === DeliveryStatus.QUOTE_UNAVAILABLE;

  if (!isDeliveryError || !unavailabilityReason) {
    return null;
  }

  const notMappedReason = !(unavailabilityReason in UnavailabilityReason);

  const unavailabilityReasonMapped: UnavailabilityReason = notMappedReason
    ? UnavailabilityReason.TECHNICAL_ISSUES
    : unavailabilityReason;

  const {
    errorModalTitleId,
    errorModalSubTitleId,
    errorModalBodyId,
    errorModalFeedbackId,
    errorModalIcon,
  } = getAllTextId(unavailabilityReasonMapped);

  return {
    errorModalTitle: formatMessage({ id: errorModalTitleId }),
    errorModalSubTitle: formatMessage({ id: errorModalSubTitleId }),
    errorModalBody: formatMessage({ id: errorModalBodyId }),
    errorModalFeedback: formatMessage({ id: errorModalFeedbackId }),
    errorModalIcon,
  };
};
